var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportpdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16927 13.333V6.54134L7.0026 8.70801L5.83594 7.49967L10.0026 3.33301L14.1693 7.49967L13.0026 8.70801L10.8359 6.54134V13.333H9.16927ZM5.0026 16.6663C4.54427 16.6663 4.15191 16.5031 3.82552 16.1768C3.49913 15.8504 3.33594 15.458 3.33594 14.9997V12.4997H5.0026V14.9997H15.0026V12.4997H16.6693V14.9997C16.6693 15.458 16.5061 15.8504 16.1797 16.1768C15.8533 16.5031 15.4609 16.6663 15.0026 16.6663H5.0026Z",
    fill: "black",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportpdf);
export default __webpack_public_path__ + "static/media/exportpdf.4117d6ef35cdb650e069842bb80c6b7c.svg";
export { ForwardRef as ReactComponent };